import axios from 'axios';

const instance = axios.create({
    baseURL: 'https://mdataws.com/portal/admin/api/',            // to be changed
    headers: {'Content-Type': 'application/json'}
});

// instance.defaults.headers.common['token'] = null;

// instance.interceptors.request.use(function (config) {
//     const token = localStorage.getItem('token');
//     if (token) {
//         config.headers.Authorization = `JWT ${token}`;

//     }
//     return config;
// });

export default instance;